import { createSelector, createSelectorFactory, defaultMemoize } from '@ngrx/store';

import { UserSelectors } from '@recruitee/account-data';
import { InterviewScheduleAssignment } from '@recruitee/http/types';
import { createEntityCollectionStore, memoizeSelector } from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<InterviewScheduleAssignment>()(
    'InterviewScheduleAssignmentsCollection',
    {
      references: makeRef => [
        makeRef('adminId', 'admin', id => createSelector(UserSelectors.byId(id!), state => state!)),
      ],
      customActions: adapter => ({
        references: (state, payload: InterviewScheduleAssignment[]) =>
          adapter.updateOrCreateMany(state, payload),
      }),
    },
  );

const InterviewScheduleAssignmentsCollectionSelectors = {
  ...selectors,
  byIds: memoizeSelector((interviewScheduleAssignmentsIds: number[]) =>
    createSelectorFactory(defaultMemoize)(
      ...interviewScheduleAssignmentsIds.map(interviewScheduleAssignmentsIds =>
        selectors.byIdWithReferences(interviewScheduleAssignmentsIds),
      ),
      (...result: InterviewScheduleAssignment[]) => result,
    ),
  ),
};

export {
  actions as InterviewScheduleAssignmentsCollectionActions,
  InterviewScheduleAssignmentsCollectionSelectors,
  reducer as InterviewScheduleAssignmentsCollectionReducer,
  namespace as InterviewScheduleAssignmentsCollectionNamespace,
};
